<div class="border border-grey-lighter rounded-xl p-4">
	<app-create-company-side-form
		label="Add Fire insurance Company"
		[minify]="true"
		(onSubmit)="_onSubmit($event)"
		(onCancel)="_onCancel()"
		[name]="name"
	>
	</app-create-company-side-form>
</div>
